import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import {ParaA} from "../SignIn"
import more from "../../../assets/more.svg"
const Sidebar = () => {
    return(
        <SideBar style={{marginTop: '0.5vh'}}>
            <Px>Categories</Px>
            <Categories>
                
                <Link to = {{pathname: '/home', category: 'Geography'}}><Category>Geography</Category></Link>
                <Link to = {{pathname: '/home', category: 'Physics'}}><CategoryX>Physics</CategoryX></Link>
                <Link to = {{pathname: '/home', category: 'History'}}><Category>History</Category></Link>
                <Link to = {{pathname: '/home', category: 'Spiritual'}}><CategoryX>Spiritual</CategoryX></Link>
                <Link to = {{pathname: '/home', category: 'Engineering'}}><Category>Engineering</Category></Link>
                <Link to = {{pathname: '/home', category: 'Psychology'}}><CategoryX>Psychology</CategoryX></Link>
                <Link to = {{pathname: '/home', category: 'Economics'}}><Category>Economics</Category></Link>
                <Link to = {{pathname: '/home', category: 'Parenting'}}><CategoryX>Parenting</CategoryX></Link>
                <Link to = {{pathname: '/home', category: 'Chemistry'}}><Category>Chemistry</Category></Link>
                <Link to = {{pathname: '/home', category: 'Business'}}><CategoryX>Business</CategoryX></Link>
                <Link to = {{pathname: '/home', category: 'Mystery'}}><Category>Mystery</Category></Link>
                <Link to = {{pathname: '/home', category: 'Biology'}}><CategoryX>Biology</CategoryX></Link>
                <Link to = {{pathname: '/home', category: 'Sociology'}}><Category>Sociology</Category></Link>
                <Link to = {{pathname: '/home', category: 'Philosophy'}}><CategoryX>Philosophy</CategoryX></Link>
                <Link to = {{pathname: '/home', category: 'Commerce'}}><Category>Commerce</Category></Link>
                <Link to = {{pathname: '/home', category: 'Maths'}}><CategoryX>Maths</CategoryX></Link>
                <Link to = {{pathname: '/home', category: 'Statistics'}}><Category>Statistics</Category></Link>
                <Link to = {{pathname: '/home', category: 'Lifestyle'}}><CategoryX>Lifestyle </CategoryX></Link>
                <Link to = {{pathname: '/home', category: 'Theater'}}><Category>Theater</Category></Link>
                <Link to = {{pathname: '/home', category: 'Design'}}><CategoryX>Design</CategoryX></Link>
            </Categories>
            <div style={{marginTop: '-4vh',display: 'flex', width: '23vw', marginLeft: '-11vw'}}>
                <Link to="/all" style={{textDecoration:"none"}}><Py>All Categories<More style={{paddingTop: '0.8vh', paddingLeft: '0.5vw'}}/></Py></Link>
            </div>
            

            <Footer>

                <Left>
                    <Link to="/about"  style={{textDecoration:"none"}}><Pz>About</Pz></Link>
                    <Link to="/terms"  style={{textDecoration:"none"}}><Pz>Terms and services</Pz></Link>
                    <Link to="/faq"  style={{textDecoration:"none"}}><Pz>FAQ's</Pz></Link>
                </Left>

                <Right>
                    <Link to="/contact"  style={{textDecoration:"none"}}><Pz>Contact</Pz></Link>
                    <Link to="/privacy"  style={{textDecoration:"none"}}><Pz>Privacy policy</Pz></Link>

                </Right>
                
            </Footer>

          <CopyRight>
          Copyright &#169;2021 Friend a Book
          <br/>
          Made with 💖 by <a target='_blank' href="https://github.com/Priyanka-Chatterjee-2000">Pri</a>
          </CopyRight>
              
        </SideBar>
    )

}
// ====================Styling Components=======================================
const SideBar = styled.div`
    /* border:2px solid red; */
    /* text-align:center; */
    background: #FFFFFF;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    z-index:0;
    display:flex;
    flex-direction:column;
    position:fixed;
    width: 19.1vw;
    box-sizing:border-box;
    height:150vh;
    left: 0px;
   // top: 12.1vh;
   overflow-y:scroll;
`;
const Px = styled(ParaA)`
    margin-top: 2.4vh;
    left: -16vw;
    position:relative;
    top: 1.5vh;
    font-weight:400;
    font-family: Rubik;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 3.2vh;

color: #000000;
`;
const Py  = styled(Px)`
    font-size:13px;
    top: 3.6vh;
    text-align:center;
    left: 0vw;
`
const Pz = styled.p`
    position:relative;
    left: 0.95vw;
    right: 0.87vw;
    color:black;
    margin-bottom: 0.76vh;
    font-family: Rubik;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 2.5vh;
    text-align: left;
   
`
const Categories = styled.div`
    text-align:center;
    position:relative;
    top: 2.74vh;
    display:flex;
    flex-direction:row;
    flex-wrap:wrap;
    justify-content:space-between;
`;
const Category = styled.button`

    background: #AFAFAF;
    border-radius: 0px 100px 100px 0px;
    border:none;
    width: 9.2vw;
    height: 6vh;
    margin-bottom: 1.5vh;
    font-family: Rubik;
    font-style: normal;
    font-weight: normal;
    font-size: 17px;
    line-height: 3vh;
    color: #FFFFFF;
    cursor: pointer;
    padding-right: 0.95vw;
`;
const CategoryX = styled(Category)`
    border-radius: 100px 0px 0px 100px;
    margin-bottom: 1.5vh;
        padding-right: 0vw;
`
const More = styled.img.attrs(props => ({
    src:more
}))`
    position:absolute;
    margin: 0.76vh 0.36vw 0.76vh 0.36vw
    text-align:center;
`;
const Footer = styled.div`
    position:relative;
      
    //bottom: 7.61vh;
    display:flex;
    flex-direction:row;
    /* align-items:center; */
    /* justify-content:space-between; */
   top:30vh;
    margin: 0.45vh 0.22vw 0.45vh 0.22vw;
`;

const CopyRight = styled(Pz)`

    position: relative;
    font-size:13px;
    top:40vh;
    text-align: center;
    margin-left: -2vw;
`
const Left = styled.div`
    display:flex;
    flex-direction:column;
    text-align:right;
    margin-right: 0.07vw
`
const Right = styled(Left)`
    margin-left: 1.75vw;
`



export default Sidebar;